import React from 'react';
import { useReveal } from '../lib/useReveal';
export function GuaranteeSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5 relative overflow-hidden" data-id="element-214">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-215">
        <div ref={ref1} className={`reveal bg-[#111111] rounded-3xl p-8 md:p-12 border border-[#eab308]/20 shadow-[0_0_40px_rgba(234,179,8,0.1)] text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-216">
          <div className="w-20 h-20 bg-gradient-to-br from-[#eab308] to-[#d4a017] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-217">
            <span className="text-4xl" data-id="element-218">🛡️</span>
          </div>

          <h2 className="text-2xl md:text-4xl font-bold text-white mb-6" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-219">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-gray-300 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-220">
            <p data-id="element-221">Abrís los tomos. Los usás en tu práctica.</p>
            <p data-id="element-222">
              Si en 7 días no es lo que esperabas — devolución del 100%. Sin
              formularios. Sin drama.
            </p>
            <p className="text-[#eab308] font-bold text-sm uppercase tracking-widest mt-6" data-id="element-223">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </div>
      </div>
    </section>;
}